import { cx } from '@/utils/strings'

type LoadingDotsProps = {
  color?: 'White' | 'Light Gray'
  size?: 'sm' | 'md'
}

export default function LoadingDots({ size = 'md', color = 'White' }: LoadingDotsProps) {
  return (
    <div className="flex justify-center gap-1">
      {[...Array(3)].map((_, index) => (
        <span
          key={index}
          className={cx(
            'flex-shrink-0 rounded-full animate-bounce',
            size === 'sm' && 'w-[6px] h-[6px]',
            size === 'md' && 'w-3 h-3',
            color === 'White' && 'bg-white',
            color === 'Light Gray' && 'bg-secondary-200'
          )}
          style={{ animationDelay: `${index * 0.2}s` }}
        />
      ))}
    </div>
  )
}
